import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
  isLoggedIn: boolean;
  redirectUrl: string;

  constructor(public afAuth: AngularFireAuth, public router: Router, public afDatabase: AngularFireDatabase){
    
    this.isLoggedIn = false;

  }
  
  authDetails: Object = {};
  
  login(email,password): Observable<any>{

    return Observable.create(observer => {
      this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((success) => {
        this.authDetails = success
        this.isLoggedIn = true
        observer.next({status: 'success', result: success})
      })
      .catch((error) =>{
        this.isLoggedIn = false
        observer.next({status: 'error', result: error})
      })
    });
  }
  isAdmin(){
    return Observable.create(observer => {
      this.afDatabase.object('auth/admin/').subscribe((result) => {
        console.log(result)
        observer.next(result)
      })
    });
  }
  userDetails(){
    return Observable.create(observer => {
      this.afDatabase.object('hoxbies/overview/'+this.authDetails['uid']).subscribe((result) =>{
        observer.next(result)
      })
    });
  }
  logout(){
    this.isLoggedIn = false;
    this.router.navigate(['/login']).then(() => {
      this.afAuth.auth.signOut();
    })
    
    
  }
}


// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/app/auth.service.ts